import { Table, TableCell, TableRow } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type Props = {
  rows: {
    no: number;
    service_title: string;
    user_name: string;
    create_at: string;
  }[];
  onSort: (column: string) => void;
};

export const ServiceReportTableContent = ({ rows, onSort }: Props) => {
  if (!rows || rows.length === 0) {
    return <div className={styles.emptyTable}>データなし</div>;
  }

  return (
    <Table
      fixedHeader
      maxHeight='min(720px, 90vh)'
      headers={[
        { label: 'No', sortable: true, onSort: () => onSort('no') },
        { label: 'サービス名', sortable: true, onSort: () => onSort('service_title') },
        { label: '名前', sortable: true, onSort: () => onSort('user_name') },
        { label: '利用日時', sortable: true, onSort: () => onSort('create_at') },
      ]}
    >
      {rows.map(row => (
        <TableRow key={row.no}>
          <TableCell>{row.no}</TableCell>
          <TableCell>{row.service_title}</TableCell>
          {/* サービス利用履歴ではプライバシーの問題から表示名を非表示化 */}
          <TableCell>非表示</TableCell>
          <TableCell>{row.create_at}</TableCell>
        </TableRow>
      ))}
    </Table>
  );
};
